module.exports = "https://cdn.hellotech.com/client-assets/other_surface_81aed68189eb0faabfcb246e8bbb8b30.png";